import styled from "styled-components";
import Icon from "../../../../../../../../../components/Icon";

export const Container = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  &:hover {
    filter: opacity(60%);
  }
`;

export const IconContent = styled.div`
  width: 44px;
  height: 44px;
  display: flex;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background-color: ${({active}) => active ? '#2634654D' : '#26346514'};
`;

export const Label = styled.label`
  color: #000;
  font-size: 12px;
  font-weight: ${({active}) => active ? 600 : 400};
`;

export const StyledIcon = styled(Icon)`
  color: #252E58;
  font-size: 24px;
`;
